<form class="m-auto auth auth-background h-100vh">
  <div class="container-fluid">
    <div class="row pi-login  justify-content-center align-items-center">
      <div class="col-md-12 ">
        <div class="header-w3l position-relative">
          <div class="logo ml-2 mt-5">
            <h3 class="d-flex justify-content-center align-items-center"><a><img src="./assets/images/Group1.png" alt=""></a></h3>
            <div style="position: absolute; top: 30%;right: 0%;" class="social-icons-insta d-flex align-items-center">
            <div class="insta">
              <img src="/assets/images/new_login_flow/instagram.svg" (click)="insta()"  class="pl-2 cursor-pointer" height="40px" alt="">
            </div>
            <div class="x">
              <img src="/assets/images/new_login_flow/x.svg" (click)="x()" class="pl-2 cursor-pointer" height="40px" alt="">
            </div>
            <div class="linkedin pr-5">
              <img src="/assets/images/new_login_flow/linkedin.svg" (click)="linkedin()" class="pl-2 cursor-pointer" height="40px" alt="">
            </div>
            </div>
          </div>
        </div>
      </div>

      <div class="containers">
        <div class="row">
          <ng-container *ngFor="let item of loginOption">
            <div class="login-option d-flex align-items-center" *ngIf="!(isLogin && item.name === 'Purple Login')"  (click)="gotologin(item)">
              <div class="hover-image code-glow">
                <img [src]="item.img" class="ml-5 mr-5 playlist-img" alt="" height="150px" width="150px">
                <span class="separator">|</span>
                <p>{{ item.name }}</p>
              </div>
            </div>          
          </ng-container>
        </div>
        <!-- <div class="row">
          <div class="col-md-12 ">
            <div class="add-playlist d-flex">
              <h5 class="ml-3 pt-1 w-25 media">{{'ADDPLAYLIST.ADD_PLAYLIST_NAME' | translate }}</h5>
              <span class="d-flex w-100 ">
                <hr class="hr-border">
              </span>
            </div>
          </div>
        </div> -->
          <!-- <div class="row pleft mt-4"> -->
            <!-- <div class="col-md-4 col-sm-1 resp" *ngIf="playlistData.login_m3u" >
              <div class="card" routerLink="/M3U-Login">
                <div class="col-md-3 d-flex align-items-center res-img ">
                  <div class="img pt-1 pl-0">
                    <img src="/assets/images/load_m3u.svg" width="50px" height="50px" alt="">
                  </div>
                </div>
                <div class="col-md-9  d-flex pl-0 ">
                  <div class="card-head ">
                    {{'ADDPLAYLIST.M3U_URL' | translate }}
                  </div>
                </div>
              
              </div>
            </div> -->
            <!-- <div class="col-md-4 col-sm-4 resp" *ngIf="playlistData.login_xtream">
              <div class="card" routerLink="/Xstream-Login">
                <div class="col-md-3 d-flex align-items-center res-img ">
                  <div class="img pt-1 pl-0">
                    <img src="./assets/images/load_xstream.svg" width="50px" height="50px" alt="">
                  </div>
                </div>
                <div class="col-md-9  d-flex pl-0">
                  <div class="card-head ">
                    {{'ADDPLAYLIST.Xstream_URL' | translate }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-sm-4 resp" >
              <div class="card" routerLink="/OneStream-Login">
                <div class="col-md-3 d-flex align-items-center res-img ">
                  <div class="img pt-1 pl-0">
                    <img src="./assets/images/load_xstream.svg" width="50px" height="50px" alt="">
                  </div>
                </div>
                <div class="col-md-9  d-flex pl-0">
                  <div class="card-head ">
                    {{'ADDPLAYLIST.One_stream_URL' | translate }}
                  </div>
                </div>
              </div>
            </div>
          </div> -->
        <!-- second card  -->
        <!-- <div class="row mt-5">
          <div class="col-md-12">
            <div class="add-playlist d-flex">
              <h5 class="ml-3 pt-1 w-25 media">{{'ADDPLAYLIST.LOGIN_OPTION' | translate}}</h5>
              <span class="d-flex w-100 ">
                <hr class="hr-border">
              </span>
            </div>

          </div>
        </div>
        <div class="row pleft mt-4">
          <div class="col-md-4 resp" *ngIf="loginDetails.login_id_pin">
            <div class="card" routerLink="/login">
              <div class="col-md-3 d-flex align-items-center res-img ">
                <div class="img pt-1 pl-0">
                  <img src="./assets/images/code.svg" width="50px" height="50px" alt="">
                </div>
              </div>
              <div class="col-md-9  d-flex pl-0">
                <div class="card-head ">
                 {{'ADDPLAYLIST.USER_ID' | translate}}
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 resp" *ngIf="loginDetails.login_code_universal">
            <div class="card" (click)="checkCodeLogin()">
              <div class="col-md-3 d-flex align-items-center res-img ">
                <div class="img pt-1 pl-0">
                  <img src="./assets/images/code.svg" width="50px" height="50px" alt="">
                </div>
              </div>
              <div class="col-md-9  d-flex pl-0">
                <div class="card-head ">
                 {{ 'ADDPLAYLIST.LOGIN_CODE' | translate}}
                </div>
              </div>
            </div>
          </div> -->
          <!-- <div class="col-md-4 resp" *ngIf="loginDetails.login_code_universal">
            <div class="card" (click)="checkCodeQr()" routerLink="/Qr-login">
              <div class="col-md-3 d-flex align-items-center res-img ">
                <div class="img pt-1 pl-0">
                  <img src="./assets/images/qr_icon.svg" width="50px" height="50px" alt="">
                </div>
              </div>
              <div class="col-md-9  d-flex pl-0">
                <div class="card-head ">
                 {{ 'LOGIN.LOGINWQR' | translate}}
                </div>
              </div>
            </div>
          </div> -->
        <!-- </div> -->
        <!-- third card  -->
        <!-- <div class="row mt-5">
          <div class="col-md-12">
            <div class="add-playlist d-flex">
              <h5 class="ml-3 pt-1 w-25 media">{{'ADDPLAYLIST.DEVICE_ACTIVATE' | translate}}</h5>
              <span class="d-flex w-100 ">
                <hr class="hr-border">
              </span>
            </div>

          </div>
        </div>
        <div class="row pleft mt-4">
          <div class="col-md-4 resp" *ngIf="deviceActivation.login_activate">
            <div class="card">
              <div class="col-md-3 d-flex align-items-center res-img ">
                <div class="img pt-1 pl-0">
                  <img src="/assets/images/code.svg" width="50px" height="50px" alt="">
                </div>
              </div>
              <div class="col-md-9  d-flex pl-0">
                <div class="card-head ">
                 {{'ADDPLAYLIST.ACTIVE_DEVICE' | translate}}
                </div>
              </div>
             
            </div>
          </div>
          <div class="col-md-4 resp" *ngIf="deviceActivation.login_mac_key">
            <div class="card ">
              <div class="col-md-3 d-flex align-items-center res-img ">
                <div class="img pt-1 pl-0">
                  <img src="/assets/images/code.svg" width="50px" height="50px" alt="">
                </div>
              </div>
              <div class="col-md-9  d-flex pl-0">
                <div class="card-head ">
                 {{'ADDPLAYLIST.MAC_KEY' | translate}}
                </div>
              </div>
             
            </div>
          </div>
        </div> -->
     
      </div>
    </div>
  </div>
</form>   
<div class="social-icons d-flex justify-content-center m-3">
  <div class="playstore d-flex pl-5 justify-content-center align-items-center">
    <div class="playstoreicon cursor-pointer">
      <img src="/assets/images/new_login_flow/googleplay.png" height="50px" alt="" (click)="googlePlay()">
    </div>
    <div class="appstore pl-2 cursor-pointer">
      <img src="/assets/images/new_login_flow/appstore.png" class="pl-2" height="50px" alt="" (click)="appStore()">
    </div>
  </div>
</div>
 <div  class="social-icons-instas pl-5 d-lg-none mb-5 d-flex align-items-center justify-content-center">
            <div class="insta">
              <img src="/assets/images/new_login_flow/instagram.svg" (click)="insta()"  class="pl-2 cursor-pointer" height="40px" alt="">
            </div>
            <div class="x">
              <img src="/assets/images/new_login_flow/x.svg" (click)="x()" class="pl-2 cursor-pointer" height="40px" alt="">
            </div>
            <div class="linkedin pr-5">
            <img src="/assets/images/new_login_flow/linkedin.svg" (click)="linkedin()" class="pl-2 cursor-pointer" height="40px" alt="">
     </div>
</div>